// GetNowButton (iter 127) — high-conversion CTA used directly under each
// plan card. Combines a soft shimmer sweep, a pulse halo, and a tiny spark
// at the front of the label for visual urgency. Pass `priceRupees` and the
// button will show "Get Now — Lock ₹X" by default.
import { ArrowRight, Sparkles } from "lucide-react";

export default function GetNowButton({
  onClick,
  priceRupees,
  label,
  testId = "get-now-btn",
  disabled = false,
  loading = false,
}) {
  const text = label || (priceRupees ? `Get Now — Lock ₹${priceRupees}` : "Get Now");
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      data-testid={testId}
      className="get-now-btn group relative mt-4 inline-flex w-full items-center justify-center gap-2 overflow-hidden rounded-xl bg-gradient-to-r from-amber-500 via-orange-500 to-rose-600 px-4 py-3 text-sm font-extrabold uppercase tracking-wide text-white shadow-lg ring-2 ring-amber-300/40 transition-all hover:-translate-y-0.5 hover:shadow-xl active:translate-y-0 disabled:opacity-70"
      aria-label={text}
    >
      {/* shimmer sweep */}
      <span aria-hidden className="pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-20deg] get-now-shimmer" />
      <Sparkles className="h-4 w-4 shrink-0 text-amber-100 drop-shadow group-hover:scale-110" />
      <span className="relative">{loading ? "Processing…" : text}</span>
      <ArrowRight className="h-4 w-4 shrink-0 transition-transform group-hover:translate-x-1" />
    </button>
  );
}
